<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：菜品管理-菜品编辑-菜品内容
    -->
  <div>
    <!--菜品详情-->
    <div class="common-form mt50">{{$t('菜品详情')}}</div>

    <!--内容-->
    <el-form-item :label="$t('内容')">
      <mi-free-time>
        <el-button @click="onRequestContent" size="small" type="warning" :loading="RequestContent_loading">{{$t('换一换')}}</el-button>
      </mi-free-time>
      <div class="edit_container" style="margin-top: 4px">
          <Uediter :text="form.model.content" v-model="content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue';
import PorductApi from '@/api/product.js';
export default {
  components: {
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 400
        }
      },
      RequestContent_loading:false,//请求数据状态
    };
  },
  created() {
    // this.ueditor.text = this.form.model.content;
  },
  inject: ['form'],
  computed: {
      content() {
         if (this.$refs.ue) {
            this.$refs.ue.setUEContent(this.form.model.content || '');
          }
        return this.form.model.content || '';
      }
    },
  methods:{

    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.model.content=e;
    },
    //菜品详情换一换
    onRequestContent()
    {

        let self = this;

        self.RequestContent_loading = true;

        PorductApi.dishInformation_description(self.form.model.product_name, {}, true).then(res => {
            self.RequestContent_loading = false;
            console.log(res.data.response);

            //菜品卖点
            self.form.model.content = res.data.response;

        }).catch(error => {
            self.RequestContent_loading = false;
        });

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/buildstore/goods/takeaway/product/part/Content.vue